import { callFunction, FUNCTIONS_URL, supabase } from "./supabase";

export interface WhatsAppDraft {
  id: string;
  revision: number;
  caption: string;
  has_media: boolean;
  post_id: string | null;
}
export function readWhatsAppDraft(requestId: string) {
  return callFunction<WhatsAppDraft>("whatsapp-post-draft", { request_id: requestId, action: "read" });
}
export async function readWhatsAppImage(requestId: string): Promise<File> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error("Sign in to review your WhatsApp draft.");
  const response = await fetch(`${FUNCTIONS_URL}/whatsapp-post-draft`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${session.access_token}` },
    body: JSON.stringify({ request_id: requestId, action: "media" }),
  });
  if (!response.ok) throw new Error("The WhatsApp image is unavailable. Upload the photo here or send it again.");
  const blob = await response.blob();
  const extension = blob.type === "image/png" ? "png" : blob.type === "image/webp" ? "webp" : "jpg";
  return new File([blob], `whatsapp-photo.${extension}`, { type: blob.type });
}

/** A canonical draft post (20260924000600): what Compose preloads from `?post=`. */
export interface PostDraft {
  id: string;
  workspace_id: string;
  caption: string;
  missing: string[];
  submitted: boolean;
  whatsapp_request_id: string | null;
  has_whatsapp_media: boolean;
}
export async function readPostDraft(postId: string): Promise<PostDraft> {
  const { data, error } = await supabase.rpc("post_draft_read", { p_post_id: postId });
  if (error || !data) throw new Error("Draft not available. Sign in to the account that sent it.");
  return data as PostDraft;
}
/** Old `?whatsapp=<request>` links: the draft post it now points to, if any. */
export async function whatsAppDraftPostId(requestId: string): Promise<string | null> {
  const { data, error } = await supabase.rpc("whatsapp_post_request_read", { p_request_id: requestId });
  if (error || !data) return null;
  const row = data as { post_id: string | null; draft_post_id?: string | null };
  return row.post_id ? null : row.draft_post_id ?? null;
}
const MISSING_LABEL: Record<string, string> = {
  photo: "a photo", photo_invalid: "a photo that fits the platforms", brand: "which brand",
  accounts: "which accounts", schedule: "a valid time", timezone: "your time zone", workspace: "a workspace",
};
export function missingSentence(missing: string[]): string {
  const parts = missing.map((m) => MISSING_LABEL[m]).filter(Boolean);
  return parts.length ? `Still needed: ${parts.join(", ")}.` : "";
}
